import { useState } from 'react'

import { Popover } from '@/components/Popover'
import { Button } from '@/components/Button'
import { Textarea } from '@/components/Textarea'
import { useUser } from '@/hooks/useUser'
import { MessageIcon } from '@/icons'

import s from './Feedback.module.css'

export const Feedback = () => {
  const [value, setValue] = useState('')
  const [showSharePopup, setShowSharePopup] = useState(false)
  const [isSending, setIsSending] = useState(false)
  const [message, setMessage] = useState('')
  const { user } = useUser()

  const sendFeedback = async () => {
    setIsSending(true)

    const formData = new FormData()
    formData.append('access_key', 'f40738c3-6e8c-4ecc-b7bc-a362cf0b0c16')
    formData.append('name', user?.name ?? 'unknown')
    formData.append('email', user?.email ?? 'unknown')
    formData.append('feedback', value)

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    })
    const data = await response.json()
    setIsSending(false)

    if (data.success) {
      setMessage('Thank you for your feedback.')
    } else {
      setMessage(data.message)
    }
  }

  return (
    <div className={s.container}>
      <Popover open={showSharePopup} onOpenChange={setShowSharePopup}>
        <Popover.Trigger>
          <button className={s.trigger}>
            <span className={s.triggerText}>Send Feedback</span>
            <span className={s.triggerTextMobile}>
              <MessageIcon />
            </span>
          </button>
        </Popover.Trigger>
        <Popover.Content title="Send Feedback" position="topRight">
          <div className={s.content}>
            {message ? (
              <div className={s.message}>
                {message}{' '}
                <Button
                  variant="ghost"
                  onClick={() => setShowSharePopup(false)}
                >
                  Hide
                </Button>
              </div>
            ) : (
              <div className={s.fieldset}>
                <Textarea
                  name="feedback"
                  placeholder="Give feedback, suggest features or report a bug."
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      value && sendFeedback()
                    }
                  }}
                  autoFocus
                  fullWidth
                />
                <div className={s.buttons}>
                  <Button
                    variant="ghost"
                    type="button"
                    disabled={isSending}
                    onClick={() => setShowSharePopup(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="button"
                    disabled={!value || isSending}
                    onClick={sendFeedback}
                  >
                    Send
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Popover.Content>
      </Popover>
    </div>
  )
}
